import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

/**
 * Réponse pour vérifier si une tentative peut être démarrée
 */
export class CanStartAttemptResponseDto {
  @ApiProperty({ description: "ID de l'activité" })
  activityId!: string

  @ApiProperty({ description: 'Peut démarrer une tentative' })
  canStart!: boolean

  @ApiPropertyOptional({ description: 'Raison si cannot start' })
  reason?: string

  @ApiPropertyOptional({ description: 'Date de disponibilité' })
  availableFrom?: Date | string

  @ApiPropertyOptional({ description: "Date d'échéance" })
  dueAt?: Date | string

  @ApiPropertyOptional({ description: 'Nombre maximum de tentatives' })
  maxAttempts?: number

  @ApiPropertyOptional({ description: 'Nombre de tentatives déjà effectuées' })
  attemptsCount?: number
}
